import UltMeta, { Meta } from "./UltMeta/index";

/** TODO: 3826 查船迁移兼容：按需求查船来源渠道占位。 */
class DrainageChannel extends UltMeta {
    UNKNOWN = new Meta("", "--");
}

/** TODO: 3826 查船迁移兼容：按需求查船类型占位。 */
class FindShipType extends UltMeta {
    UNKNOWN = new Meta("", "--");
}

/** TODO: 3826 查船迁移兼容：标记形状占位。 */
class FenceMarkShapeType extends UltMeta {
    POLYGON = new Meta(1, "多边形");
    CIRCLE = new Meta(2, "圆形");
}

/** TODO: 3826 查船迁移兼容：是否微信提醒占位。 */
class IsWechatReminder extends UltMeta {
    YES = new Meta(1, "是");
    NO = new Meta(0, "否");
}

/** TODO: 3826 查船迁移兼容：电子围栏监控行为占位。 */
class FenceReminderRecordsMonitorBehavior extends UltMeta {
    ENTERAREA = new Meta(1, "驶入");
    LEAVEAREA = new Meta(2, "驶出");
}

export const DRAINAGE_CHANNEL = new DrainageChannel();
export const FIND_SHIP_TYPE = new FindShipType();
export const FENCE_MARK_SHAPE_TYPE = new FenceMarkShapeType();
export const IS_WECHAT_REMINDER = new IsWechatReminder();
export const FENCE_REMINDER_RECORDS_MONITOR_BEHAVIOR = new FenceReminderRecordsMonitorBehavior();
